<div class="chord-indicator" role="status" aria-live="polite">
  <span class="chord-indicator-title"><kbd>{{ shortcutPrefix() }}</kbd> then a key…</span>
  @for (row of shortcutRows(); track $index) {
    <div class="chord-row">
      @for (shortcut of row; track shortcut.key) {
        <span class="chord-tile">
            <kbd>{{ shortcut.key }}</kbd>
            <span class="chord-tile-label">{{ shortcut.label }}</span>
          </span>
      }
    </div>
  }
</div>
